import { render, staticRenderFns } from "./NgSwitchBasic.vue?vue&type=template&id=14cb8646"
import script from "./NgSwitchBasic.vue?vue&type=script&lang=js"
export * from "./NgSwitchBasic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports